import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  descriptive: {
    fontSize: '9px'
  },
  input: {
    width: '50%',
  },
  box: {
    [theme.breakpoints.up('md')]: { height: '30px ' },
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  textLabel: {
    maxWidth: '300px',
  },
  parentContainer: {
    paddingBottom: '50px',
  },
  submitRow: {
    float: 'right',
  },
  helperText: {
    color: 'red'
  }
}));

export default useStyles;
